module.exports = __webpack_public_path__ + "static/media/dropper-medical-pipette-svgrepo-com.960d5d77.svg";